import { useEffect, useState } from 'react';

/** How long a typed filter waits for a pause before it is sent. */
export const TYPING_DEBOUNCE_MS = 300;

/**
 * Delays a value until it stops changing, so typing into a filter does not
 * fire a request per keystroke.
 */
export function useDebounced<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
